module.exports = __webpack_public_path__ + "img/RIDF_laurels_no_audience_winner.33f47b27.png";